import "core-js/modules/es.promise.finally.js";
import ctripCard from './components/ctripCard.vue';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
import { addPvNew, fetchData, getUrlParams } from '../../../../utils';
export default {
  data() {
    const {
      cityid = ''
    } = getUrlParams(location.href);
    return {
      isCardScroll: false,
      ctripCardData: [],
      cityid
    };
  },
  components: {
    ctripCard
  },
  props: {
    source: {
      type: String,
      default: ''
    },
    phoneInfo: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    if (this.source === 'xiechengzhinan') {
      this.getGuideCard();
    }
  },
  methods: {
    // 指南豆腐块
    getGuideCard() {
      const {
        cuid,
        os,
        sv
      } = this.phoneInfo || {};
      const params = {
        os,
        sv,
        cuid,
        city_id: this.cityid,
        card_type: 'ctrip_compass'
      };
      const url = '/feed-server/mapdetail/cardlist';
      fetchData(url, {
        method: 'get',
        params
      }).then(res => {
        const {
          errno,
          data: {
            ctrip_compass_posts: ctripCompassPosts = []
          } = {}
        } = res || {};
        if (errno === 0) {
          this.ctripCardData = ctripCompassPosts;
          if (this.ctripCardData.length > 0) {
            addPvNew(['POIsheet2_bdzn_xiechengznz.show']);
          }
        }
      }).catch(err => {}).finally(() => {
        this.$emit('emitCtripCardData', this.ctripCardData.length > 0);
      });
    },
    /**
     * 跳转笔记详情h5
     *
     * @param item - 当前卡数据
     */
    goDetail(item, index) {
      const {
        jump_url = ''
      } = item || {};
      addPvNew(['POIsheet2_bdzn_xiechengznz.click'], {
        pos: index + 1,
        title: item.headline
      });
      openUrlByOpenApi(jump_url);
    },
    scrollCard() {
      if (!this.isCardScroll) {
        this.isCardScroll = true;
        addPvNew(['POIsheet2_bdzn_xiechengznz.slide']);
      }
    }
  }
};